export const enum GalleryType {
  Masonry = 'masonry',
  Swiper = 'swiper',
}
